import styled from 'styled-components';

import { DefaultTheme } from '../../theme/branches/Colors';

export const Wrapper = styled.div`
  position: absolute;
  width: auto;
  min-width: 100%;
  padding-left: ${({ theme }): string => theme.spacers!.spacer04};
  right: 0;
  top: 40px;
  z-index: 1500;
`;

export const Card = styled.div`
  background: ${({ theme }): string => theme.colors!.colorWhite};
  border-radius: ${({ theme }): string => theme.spacers!.spacer03};
  width: 100%;
  cursor: pointer;
  box-shadow: 0 3px 16px -8px rgb(19 32 57 / 40%);

  span:first-child {
    border-top-left-radius: ${({ theme }): string => theme.spacers!.spacer02};
    border-top-right-radius: ${({ theme }): string => theme.spacers!.spacer02};
  }

  span:last-child {
    border-bottom-left-radius: ${({ theme }): string => theme.spacers!.spacer02};
    border-bottom-right-radius: ${({ theme }): string => theme.spacers!.spacer02};
  }
`;

const getBgColor = (disabled: boolean, selected: boolean): string => {
  if (disabled) return DefaultTheme.admanColors.gray.light.bg0[4];

  return selected ? DefaultTheme.admanColors!.blue.light.fg[3] : DefaultTheme.admanColors!.gray.light.bg0[0];
};

export const Title = styled.span<{ $disabled: boolean; $selected: boolean }>`
  display: block;
  list-style: none;
  padding: ${({ theme }): string => theme.spacers!.spacer03};
  font-family: InspireTWDC;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  color: ${({ theme }): string => theme.admanColors!.blue.dark.bg1[0]};
  background-color: ${({ $disabled, $selected }): string => getBgColor($disabled, $selected)};
  cursor: ${({ $disabled }): string => ($disabled ? 'default' : 'pointer')};
  height: 45px;
  border-bottom: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.bg3[2]};

  &:hover {
    background-color: ${({ theme, $disabled }): string =>
      $disabled ? theme.admanColors!.gray.light.bg0[4] : theme.admanColors!.blue.light.fg[2]};
    color: ${({ theme }): string => theme.admanColors!.gray.dark.fg1[2]};
  }
`;
